import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/** Kimenő küldemények: feladás, ragszám, tértivevény visszavezetése. */
@Component({
  selector: 'app-ikt-postakonyv',
  templateUrl: './postakonyv.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktPostakonyvComponent implements OnInit {
  sorok: any[] = [];
  betoltes = false;
  uj: any = { irat: '', cimzett_nev: '', cimzett_cim: '', kuldes_mod: 'ajanlott', feladva: '', ragszam: '' };
  ujForm = false;

  constructor(private ikt: IktatgatoService, private data: DataService,
              private route: ActivatedRoute, private router: Router) {}

  /** A postakönyv-sor állapota emberi néven – ugyanazok a szavak, mint a naplóban. */
  allapotNev(s: any): string {
    return ({
      elokeszitve: 'előkészítve', feladasra_var: 'feladásra vár', elkuldve: 'elküldve',
      feladva: 'feladva', kezbesitve: 'kézbesítve', atveve: 'átvéve',
      meghiusult: 'meghiúsult', visszahivva: 'visszahívva', hiba: 'hiba',
    } as any)[s?.statusz] || s?.statusz || '—';
  }

  /*  HOL TART A KÜLDEMÉNY? Az életutat – feladási és letöltési igazolásokkal – a
   *  kézbesítési napló mutatja, mert az minden csatornára közös. Innen oda ugrunk,
   *  erre a küldeményre szűrve. */
  eletut(s: any) {
    this.router.navigate(['/iktatgato/kezbesites'], {
      queryParams: { q: s?.kulso_azonosito || s?.iktatoszam || s?.cimzett_nev || '' },
    });
  }

  async ngOnInit() {
    const irat = this.route.snapshot.queryParamMap.get('irat');
    if (irat) {
      this.uj.irat = irat; this.ujForm = true;
      //  A címzett az irat partnere – ne kelljen újra begépelni (Libus Ágnes, #1077).
      try {
        const r: any = await this.ikt.irat(irat);
        this.uj.cimzett_nev ||= r?.irat?.partner_nev || '';
        this.uj.cimzett_cim ||= r?.irat?.partner_cim || '';
      } catch (e) { /* kézzel is kitölthető */ }
    }
    await this.betolt();
  }

  async betolt() {
    this.betoltes = true;
    try { this.sorok = await this.ikt.postakonyv(); }
    catch (e: any) { this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni a postakönyvet.', 'error'); }
    finally { this.betoltes = false; }
  }

  async felvesz() {
    if (!this.uj.irat || !this.uj.cimzett_nev) {
      this.data.sendToast('Az irat és a címzett kötelező.', 'warning');
      return;
    }
    try {
      await this.ikt.postaraTesz(this.uj);
      this.data.sendToast('Felvéve a postakönyvbe.');
      this.ujForm = false;
      this.uj = { irat: '', cimzett_nev: '', cimzett_cim: '', kuldes_mod: 'ajanlott', feladva: '', ragszam: '' };
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A felvétel nem sikerült.', 'error');
    }
  }

  async modosit(s: any, adat: any) {
    try {
      await this.ikt.postaModosit(s.id, adat);
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    }
  }

  ma(): string {
    const d = new Date();
    const p = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  }
}
